import { BUILDING_LOCKED_TOOLTIP_POSITION } from '@/map-phaser-new/constants'
import type { BuildingConfigInterface } from '@/map-phaser-new/interfaces'

export const restaurantConfig: BuildingConfigInterface = {
  textureKey: 'clubsBuildings',
  frameKey: 'restaurant',
  routeConfig: {
    routeName: 'ClubsRestaurant',
    soundName: 'click-map-artefact',
    isRouteParamIdNeeded: false,
  },
  positionX: 2074,
  positionY: 465,
  depth: 4,
  originX: 0,
  keyForTranslateTitle: 'club.restaurant',
  buildingTitleConfig: {
    positionX: 2185,
    positionY: 715,
    depth: 7,
    textConfig: {
      originX: 0.5,
      positionX: -40,
      fontName: 'Nunito Sans',
      fontSize: '24px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontColor: '#fff',
    },
    backgroundImageConfig: {
      textureName: 'common',
      frameNameRightSide: 'right_side',
      frameNameRightSideLocked: 'right_side_locked',
      frameNameLeftSide: 'left_side',
      frameNameLeftSideLocked: 'left_side_locked',
      originX: 0.5,
      widthCorrection: 100,
      heightCorrection: 10,
    },
  },
  outlineConfig: {
    framePostFix: '_outline',
    depth: 6,
    originX: 0,
    positionByLevel: {
      '1': { positionX: 2074, positionY: 465 },
    },
    textureKey: 'clubsBuildingsOutlines',
  },
  inputConfig: {
    useHandCursor: true,
  },
  buildingLockedConfig: {
    textureKey: 'clubsLockedBuildings',
    framePostfix: '_locked',
    lockImageTextureKey: 'lock',
    positionX: 2202,
    positionY: 603,
    lockImageDepth: 6,
    depth: 5,
    tooltipConfig: {
      tooltipPosition: BUILDING_LOCKED_TOOLTIP_POSITION.Top,
      tooltipTextureHeight: '213px',
      tooltipTextureWidth: '444px',
      depth: 10,
      titleConfig: {
        originX: 0.5,
        fontSize: '30px',
        fontName: 'Nunito Sans',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontColor: '#fff',
      },
      subtitleConfig: {
        originX: 0.5,
        originY: 0.5,
        fontName: 'Nunito Sans',
        fontSize: '24px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontColor: '#fff',
        replaceFontColor: '#fec742',
        tooltipSubtitleTranslateKey: 'club.unlockLevel',
        tooltipSubtitleReplaceFlag: '%s',
        tooltipSubtitleReplaceTags: { start: '{b}', end: '{/b}' },
      },
      tooltipHideDelay: 2000,
      tooltipLeftTextureName: 'building_tooltip_left',
      tooltipRightTextureName: 'building_tooltip_right',
      tooltipTopTextureName: 'building_tooltip_top',
    },
  },
}
